export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAzzlTFyZikYaiAaeOgP-3Uh4ngPQovtlA',
    authDomain: 'servlymaindev.firebaseapp.com',
    databaseURL: 'https://servlymaindev.firebaseio.com',
    projectId: 'servlymaindev',
    storageBucket: 'servlymaindev.appspot.com',
    messagingSenderId: '116569791735',
    appId: '1:116569791735:web:2541366c18ba976e46c7f2',
    measurementId: 'G-MCQTE0FPQE',
  },
  mercantilUrl:
    'https://payment-gateway-frontend-test-2.desqa-ve-ocp-m3c-8x64-2a9350942ee55c9d16ed89a864995080-0000.us-south.containers.appdomain.cloud',
  returnUrl: 'https://www.google.com',
  api: 'https://mbdev.myservy.com',
  appurl: 'https://sc-sit.myservy.com',
  apimyservy: 'https://sm-sit.myservy.com',
  urlFuntionEmailConfirm:
    'https://us-central1-servlymaindev.cloudfunctions.net/EmailConfirm?param=',
  urlFuntionDeleteUser:
    'https://us-central1-servlymaindev.cloudfunctions.net/DeleteUser?param=',
  useFunctionsEmulator: false,
  restricion: false,
  listBtn: '151cuenta-uno',
  qrLink: 'https://tarjetadigital.myservy.com/',
  recharges: [
    {
      servicecenterId: '0c8477a5-1864-4d56-961f-468e5d7bbc8d',
      plan30: {
        name: '30 días',
        description: 'Servicio Fibra Cool 50 MPS x 30 Días x 25 $',
        amountoftime: 30,
        amount: 1.2,
      },
      plan10: {
        name: '10 días',
        description: 'Servicio Fibra Cool 50 MPS x 10 Días x  10$',
        amountoftime: 10,
        amount: 0.8,
      },
    },
    {
      servicecenterId: '0f63d5f6-bd12-493c-9d48-f8ac283e603a',
      plan30: {
        name: '30 días',
        description: 'Servicio Fibra Cool 50 MPS x 30 Días x 25 $',
        amountoftime: 30,
        amount: 1.0,
      },
      plan10: {
        name: '10 días',
        description: 'Servicio Fibra Cool 50 MPS x 10 Días x  10$',
        amountoftime: 10,
        amount: 0.5,
      },
    }
  ],
};
//Cambios
